import { render, staticRenderFns } from "./TraineeTable.vue?vue&type=template&id=1ef1778a"
import script from "./TraineeTable.vue?vue&type=script&lang=js"
export * from "./TraineeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports